import { Injectable } from '@angular/core';

import { GraphQLService } from '@app/services';
import { 
    mutationRespond, mutationRespondSale
} from '@app/graphql-queries';

@Injectable({
  providedIn: 'root'
})
export class ResponseService {
    
    constructor(
        private graphQLService: GraphQLService
    ) { }
    
    async postResponse(responseID: string|undefined, challengeID: string, responseType: string, responseValue: any, comment: string|null, optionalsMedias:Array<string>): Promise<{status: boolean, error?: string}> {
        let data: {status: boolean, error?: string} = {status: false};
        let params = {
            ID: responseID,
            challengeID: challengeID,
            typeResponse: responseType,
            response: responseValue,
            comment: comment,
            optionalsMedias: optionalsMedias
        };
        let response = await this.graphQLService.mutate({   
            mutation: mutationRespond,
            variables: {
                params: JSON.stringify(params),
            },      
        });   
        if(response?.error){
            data.error = response.error.message;
        }  
        else if(response?.data?.PostResponse){
            data.status = true;
        }        
        return data;
    }
    
    async postResponseSale(responseID: string|undefined, ambassadorID: string, matchID: string, responseType: string, responseValue: any, comment: string|null, optionalsMedias:Array<string>): Promise<{status: boolean, error?: string}>{
        let data: {status: boolean, error?: string} = {status: false};
        let params = {
            ID: responseID,
            matchID: matchID,
            challengeID: 'sale',
            typeResponse: responseType,
            response: responseValue,
            comment: comment,
            optionalsMedias: optionalsMedias
        };
        let response = await this.graphQLService.mutate({   
            mutation: mutationRespondSale,
            variables: {
                ambassadorID: ambassadorID,
                params: JSON.stringify(params),
            },      
        }, 'public');  
        if(response?.error){
            data.error = response.error.message;
        }
        else if(response?.data?.PostResponse){
            data.status = true;
        }        
        return data;
    }
}
